<template>
  <div class="mb-4">
    <div class="flex justify-center items-baseline py-6">
      <Multiselect
        id="groups"
        v-model="selectedGroups"
        :options="membershipGroups"
        :multiple="true"
        label="title"
        track-by="uuid"
        :close-on-select="false"
        :clear-on-select="false"
        :hide-selected="true"
        placeholder="Select Groups..."
        open-direction="bottom"
        :loading="loading"
        @search-change="handleSearchChange"
        @input="groupsSelected"
      />
    </div>
  </div>
</template>

<script type="text/babel">
import { mapState, mapActions } from 'vuex'
import { debounce } from 'lodash'
import Multiselect from 'vue-multiselect'

export default {
  name: 'MembershipGroupListSelector',
  components: {
    Multiselect,
  },
  props: {
    preSelectedGroups: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      loading: true,
      selectedGroups: [],
    }
  },
  computed: {
    ...mapState({
      membershipGroups: state => state.membership.membershipGroups.data.map((group) => {
        return { uuid: group.uuid, title: group.attributes.title }
      }),
    }),
    show() {
      return this.$store.state.communication.sendToGroupsModal.open
    },
  },
  watch: {
    preSelectedGroups() {
      this.selectedGroups = this.preSelectedGroups.map((group) => {
        return { uuid: group.uuid, title: group.attributes.title }
      })
    },
  },
  beforeMount() {
    this.fetchMembershipGroups().then(() => {
      this.loading = false

      this.selectedGroups = this.preSelectedGroups.map((group) => {
        return { uuid: group.uuid, title: group.attributes.title }
      })
    })
  },
  methods: {
    ...mapActions({
      fetchMembershipGroups: 'membershipGetMembershipGroups',
    }),
    handleSearchChange: debounce(function (search) {
      this.isLoadingGroups = true

      this.fetchMembershipGroups({
        params: {
          query: search,
        },
      }).then(() => {
        this.loading= false
      })
    }, 500),
    groupsSelected() {
      this.$emit('input', this.selectedGroups)
    },
  },
}
</script>
